import { useEffect, useId, useRef, type ReactNode } from 'react';

/** A modal dialog; slides up from the bottom on phones. */
export function Sheet({ open, onClose, title, children }: { open: boolean; onClose: () => void; title: string; children: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      className="sheet"
      aria-labelledby={titleId}
      onClose={onClose}
      // A click on the dialog element itself (not its content) is the backdrop.
      onClick={(e) => e.target === ref.current && onClose()}
    >
      <div className="sheet-body">
        <header className="row">
          <h2 id={titleId} className="grow">
            {title}
          </h2>
          <button type="button" className="btn small" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </header>
        {open && children}
      </div>
    </dialog>
  );
}
